import { EmptyState, useMediaQuery } from "@blend-ed/blendx-ui";
import { injectIntl } from "@edx/frontend-platform/i18n";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import EventCard from "../../../components/EventCard";
import useCalendarEvents from "../../../hooks/useCalendarEvents";
import messages from "../messages";

const UpcomingEvents = ({ intl }) => {
  const { events, loading, error } = useCalendarEvents(true);
  const { isTablet } = useMediaQuery({ query: '(min-width: 768px)' });

  return (
    <div className="upcoming-events-container">
      <div className="upcoming-events__header">
        <div className="upcoming-events__title">{intl.formatMessage(messages.upcomingEvents)}</div>
        {isTablet && <Link to="calendar" className="upcoming-events__link">
          {intl.formatMessage(messages.seeAll)}
        </Link>}
      </div>
      {events.length > 0 ? (
        events.slice(0, 1).map((event, index) => (
          <EventCard
            key={index}
            date={event.start}
            variant={event.variant}
            title={event.title}
            description={event.description}
            link={event.link}
          />
        ))
      ) : (
        <EmptyState type="calendar" message={intl.formatMessage(messages.noEventsFound)} />
      )}
    </div>
  );
}

UpcomingEvents.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default injectIntl(UpcomingEvents);